<div class="row">
  <div class="col-md-10 col-10">
    <h3 class="text-blue mb-1" mat-dialog-title>{{ 'Location' | translate }}</h3>
    <p>{{address}}</p>
  </div>
  <div class="col-md-2 col-2 p-0">
    <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()">
      <fa-icon [icon]="faTimesCircle"></fa-icon>
    </button>
  </div>
</div>




<mat-dialog-content>
  <!-- <h1>address: {{address}}</h1>
  <div>Latitude: {{latitude}}</div>
  <div>Longitude: {{longitude}}</div> -->
  <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">

    <ng-container *ngFor="let item of marker">
      <agm-marker [latitude]="item.lat" [longitude]="item.lng" [markerDraggable]="markerDraggable"

      (dragEnd)="markerDragEnd($event)"></agm-marker>
    </ng-container>


    <agm-circle *ngIf="circleCoordinate!=null" [latitude]="circleCoordinate.lat" [longitude]="circleCoordinate.lng"
      [radius]="radiusMeter" [circleDraggable]="false" [fillColor]="'purple'" [strokeColor]="'red'">

    </agm-circle>




  </agm-map>
</mat-dialog-content>
